import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Home, Search, ArrowRight, Package, AlertTriangle } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import constructionImage from "@/assets/404-construction.jpg";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />

      <main className="flex-1 flex items-center justify-center p-4 pt-36 lg:pt-16">
        <Card className="max-w-4xl w-full shadow-2xl border-0 bg-card/95 backdrop-blur-sm">
          <CardContent className="p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              {/* Construction Image */}
              <div className="order-2 md:order-1">
                <img
                  src={constructionImage}
                  alt="404 Construction Site"
                  className="w-full h-auto rounded-lg opacity-80"
                />
              </div>

              {/* Content */}
              <div className="order-1 md:order-2 text-center md:text-right" dir="rtl">
                <div className="space-y-6">
                  <div className="text-6xl md:text-8xl font-bold text-primary/30 select-none">404</div>

                  <h1 className="text-2xl md:text-3xl font-bold text-foreground">
                    אופס! הדף שחיפשת לא נמצא
                  </h1>

                  <p className="text-lg text-muted-foreground leading-relaxed">
                    נראה שהדף שביקשת אינו קיים או שהכתובת שונתה.
                    בואו נמצא את מה שאתם מחפשים!
                  </p>

                  {/* Action buttons */}
                  <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start items-center mt-8">
                    <Button
                      onClick={() => navigate('/')}
                      className="bg-primary hover:bg-primary/90 text-primary-foreground gap-2 px-6 py-3"
                    >
                      <Home className="w-5 h-5" />
                      חזרה לעמוד הבית
                    </Button>

                    <Button
                      variant="outline"
                      onClick={() => navigate('/products')}
                      className="gap-2 px-6 py-3"
                    >
                      <Package className="w-5 h-5" />
                      עיון במוצרים
                    </Button>
                  </div>

                  {/* Popular suggestions */}
                  <div className="mt-8 p-6 bg-muted/30 rounded-lg">
                    <h3 className="text-lg font-semibold mb-4 text-foreground">
                      דפים פופולריים:
                    </h3>
                    <div className="grid grid-cols-2 gap-2">
                      <Button
                        variant="ghost"
                        onClick={() => navigate('/categories')}
                        className="justify-start gap-2 text-right text-sm"
                        size="sm"
                      >
                        קטגוריות
                      </Button>
                      <Button
                        variant="ghost"
                        onClick={() => navigate('/about')}
                        className="justify-start gap-2 text-right text-sm"
                        size="sm"
                      >
                        אודותינו
                      </Button>
                      <Button
                        variant="ghost"
                        onClick={() => navigate('/contact')}
                        className="justify-start gap-2 text-right text-sm"
                        size="sm"
                      >
                        צור קשר
                      </Button>
                      <Button
                        variant="ghost"
                        onClick={() => navigate('/profile')}
                        className="justify-start gap-2 text-right text-sm"
                        size="sm"
                      >
                        אזור אישי
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
